import React from "react";
import {
  Grid,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import {
  CustomSecondaryEditButton,
  CustomSecondaryDownLoadButton,
  CustomSecondaryButton,
  CustomSuccessButton,
} from "../../../../../Global_Component/GlobalButtonComponent";


const MeatList = () => {
  const products = [
    {
      id: 1,
      name: "Chicken Jalfrezi Recipe (Restaurant Style)",
      category: "North Indian",
      price: "₹ 499",
      availableTime: "10:00 am - 09:00 pm",
    },
    {
      id: 2,
      name: "Malai Chicken Recipe",
      category: "South Indian",
      price: "₹ 350",
      availableTime: "10:00 am - 09:00 pm",
    },
    {
      id: 3,
      name: "Chicken Tikka Masala Recipe",
      category: "Continental",
      price: "₹ 699",
      availableTime: "10:00 am - 09:00 pm",
    },
    {
      id: 4,
      name: "Palak Chicken (Chicken Spinach Curry)",
      category: "North Indian",
      price: "₹ 400",
      availableTime: "10:00 am - 09:00 pm",
    },
    {
      id: 5,
      name: "Chicken Biryani Recipe",
      category: "North Indian",
      price: "₹ 499",
      availableTime: "10:00 am - 09:00 pm",
    },
  ];

  return (
    <Box sx={{ padding: "16px" }}>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          Menu List
        </Typography>
        <Box>
          <CustomSecondaryDownLoadButton sx={{ mr: 1 }} label={"Download"} />
          <CustomSecondaryEditButton sx={{ mr: 1 }} label={"Edit"} />
        </Box>
      </Grid>

      <TableContainer sx={{ border: "1px solid #ddd", borderRadius: "8px" }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#F9FAFC" }}>
              <TableCell sx={{ fontWeight: "500" }}>SL No.</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>
                Product name / Name of dish
              </TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Category</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Price</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Available time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {products.map((product, index) => (
              <TableRow key={product.id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{product.name}</TableCell>
                <TableCell>{product.category}</TableCell>
                <TableCell>{product.price}</TableCell>
                <TableCell>{product.availableTime}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Grid
        xs={12}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 1,
          my: 2,
        }}
      >
        <CustomSecondaryButton label={"Back"} />
        <CustomSuccessButton label={"Approve & Continue"} />
      </Grid>
    </Box>
  );
};

export default MeatList;
